var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"page-container",attrs:{"fluid":""}},[_c('labs-wandh-input-form',{attrs:{"state":'idle'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }